import { removeOrgPrefix } from '@utils/routes';
import { isValidObjectId } from '@utils/validation';
import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

/**
 * Validates that the orgId parameter is a well-formed org-{objectid} path.
 * If not, redirects to the root path.
 *
 * Checking only the `org-` prefix is not enough: `/org-/qc` (empty org id) and
 * an external `/qc` link both slip a non-ObjectID value through to the API,
 * which then 500s (AQ-749). Require a valid ObjectID after the prefix.
 */
export const OrgRouteValidator: React.FC = () => {
  const { orgId } = useParams<{ orgId: string }>();

  if (!orgId || !isValidObjectId(removeOrgPrefix(orgId))) {
    // Missing, empty, or malformed org id — redirect to root.
    return <Navigate to="/" replace />;
  }

  // Valid orgId, render child routes
  return <Outlet />;
};
